import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/Virock-twitter-profile.webp")